export default (function (instanceId, context) {
  if (context !== null && context !== void 0 && context.managers) {
    return context.managers.find(function (entry) {
      return entry.instanceId === instanceId;
    });
  }
  return null;
});